import { render, staticRenderFns } from "./ListDutsNaviTrack2TcpServerPage.vue?vue&type=template&id=08c4bdcb"
import script from "./ListDutsNaviTrack2TcpServerPage.vue?vue&type=script&lang=js"
export * from "./ListDutsNaviTrack2TcpServerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports